import * as v from "valibot";
import { rpcContract } from "../rpc";

/**
 * Create subscription tier for creator
 * ONE subscription tier per creator (enforced by database)
 * This is typically auto-created on first premium content
 */
export const createSubscriptionTierRpcContract = rpcContract({
  name: "create-subscription-tier",
  paramsSchema: v.object({
    name: v.optional(v.pipe(v.string(), v.minLength(1), v.maxLength(100))),
    description: v.optional(v.pipe(v.string(), v.maxLength(500))),
    monthlyPriceCents: v.pipe(v.number(), v.minValue(100), v.maxValue(99999)),
  }),
  resultSchema: v.object({
    tierId: v.string(),
    stripeProductId: v.string(),
    stripePriceId: v.string(),
    monthlyPriceCents: v.number(),
  }),
});

export type CreateSubscriptionTierParams = v.InferOutput<(typeof createSubscriptionTierRpcContract)["paramsSchema"]>;
export type CreateSubscriptionTierResult = v.InferOutput<(typeof createSubscriptionTierRpcContract)["resultSchema"]>;
